import { Box, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import Steps from './Steps'
import ReferralCard from './ReferralCard'

/**
 * Components wraps referral content which is displayed in different order based on the breakpoint.
 */
const ReferralContentWrapper: React.FC = () => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  if (downSm)
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2, gap: 4 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <ReferralCard />
          <Steps />
        </Box>
      </Box>
    )

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2, gap: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4 }}>
        <ReferralCard />
        <Steps />
      </Box>
    </Box>
  )
}

export default ReferralContentWrapper
